import MessageAdListViewStatusStore from '../store/schema/MessageAdListViewStatusStore';
import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';

export interface ResetMessageAdListSelectionState {
    messageAdListViewStatusStore: MessageAdListViewStatusStore;
}

export default select<ResetMessageAdListSelectionState>({
    messageAdListViewStatusStore: () => store,
})(
    action('resetMessageAdListSelection')(function (
        state?: ResetMessageAdListSelectionState
    ): void {
        if (state?.messageAdListViewStatusStore) {
            state.messageAdListViewStatusStore.selectedAdId = null;
        }
    })
);
